import { ROUTE_CONSTANTS } from '@app/core/constants/route.constant';
import { IOnboardingStatus, IOnboardingStepDef } from '../interfaces/onboarding.interface';

/** Query param that opens a getting-started dialog on the page, e.g. the training times in the calendar. */
export const ONBOARDING_SETUP_PARAM = 'setup';
export const ONBOARDING_SETUP_TIMES = 'times';

/**
 * Getting-started steps, in the order a new coach is meant to work through them. Registering already
 * counts as the first step, so a new coach starts at "1 of 5" (endowed progress effect: a head start
 * makes finishing likelier). Each other step leaves real data behind: a session, the whole squad, the
 * weekly training times on the calendar, a co-coach who has the plan.
 */
export const ONBOARDING_STEPS: IOnboardingStepDef[] = [
    {
        key: 'accountCreated',
        label: 'onboarding.steps.account',
        route: ['/', ROUTE_CONSTANTS.USER.ROOT, ROUTE_CONSTANTS.USER.ACCOUNT],
    },
    { key: 'sessionCreated', label: 'onboarding.steps.session', route: ['/', ROUTE_CONSTANTS.HOME] },
    { key: 'squadComplete', label: 'onboarding.steps.squad', route: ['/', ROUTE_CONSTANTS.SQUAD] },
    {
        key: 'trainingTimesSet',
        label: 'onboarding.steps.trainingTimes',
        route: ['/', ROUTE_CONSTANTS.CALENDAR],
        queryParams: { [ONBOARDING_SETUP_PARAM]: ONBOARDING_SETUP_TIMES },
    },
    { key: 'planShared', label: 'onboarding.steps.share', route: ['/', ROUTE_CONSTANTS.SESSIONS] },
];

/** "3/16" for the squad step while the squad is not complete; null for every other step. */
export function onboardingStepProgress(status: IOnboardingStatus | null, step: IOnboardingStepDef): string | null {
    if (step.key !== 'squadComplete' || !status?.squad || status.steps.squadComplete) {
        return null;
    }
    return `${Math.min(status.squad.players, status.squad.target)}/${status.squad.target}`;
}

export function isOnboardingStepDone(status: IOnboardingStatus | null, step: IOnboardingStepDef): boolean {
    return step.key === 'accountCreated' || !!status?.steps[step.key];
}
